<template>
  <div v-if="visible" class="overlay">
    <div class="card">
      <h3 v-if="status==='uploading'">Envoi en cours…</h3>
      <h3 v-else-if="status==='done'">Transfert terminé</h3>
      <h3 v-else>Échec de l’envoi</h3>

      <div class="meter">
        <div class="bar" :style="{ width: (progress*100).toFixed(1) + '%' }"></div>
      </div>

      <div class="stats">
        <div>{{ percent }}%</div>
        <div>{{ transferredStr }} / {{ totalStr }}</div>
        <div v-if="status==='uploading'">{{ speedStr }} • reste ~ {{ etaStr }}</div>

        <div v-if="uploadId" class="upload-id">
          Identifiant fichiers : <code>{{ uploadId }}</code>
          <button class="copy" @click="copy(uploadId)">Copier</button>
        </div>

        <div v-if="manageId" class="upload-id">
          Identifiant gestion : <code>{{ manageId }}</code>
          <button class="copy" @click="copy(manageId)">Copier</button>
        </div>

        <div v-if="shareLink" class="upload-id">
          Lien de partage :
          <code class="truncate">{{ shareLink }}</code>
          <button class="copy" @click="copy(shareLink)">Copier</button>
          <a class="copy" :href="shareLink" target="_blank" rel="noopener">Ouvrir</a>
        </div>

        <div v-if="manageLink" class="upload-id">
          Lien de gestion :
          <code class="truncate">{{ manageLink }}</code>
          <button class="copy" @click="copy(manageLink)">Copier</button>
          <a class="copy" :href="manageLink" target="_blank" rel="noopener">Ouvrir</a>
        </div>

        <div v-if="emailLinked" class="hint">
          Partage lié à l’adresse e-mail fournie.
        </div>
      </div>

      <div class="actions">
        <button :disabled="status==='uploading'" @click="$emit('close')">Fermer</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UploadModal',

  props: {
    visible: Boolean,
    progress: {type: Number, default: 0},
    transferred: {type: Number, default: 0},
    total: {type: Number, default: 0},
    speedBps: {type: Number, default: 0},
    etaSec: {type: Number, default: 0},
    uploadId: {type: String, default: ''},
    manageId: {type: String, default: ''},
    emailLinked: {type: Boolean, default: false},
    status: {type: String, default: 'idle'},
    shareLink: {type: String, default: ''},
    manageLink: {type: String, default: ''}
  },

  computed: {
    percent() {
      return Math.min(100, Math.round(this.progress * 100));
    },

    transferredStr() {
      return this.fmtBytes(this.transferred);
    },

    totalStr() {
      return this.fmtBytes(this.total);
    },

    speedStr() {
      return this.fmtBytes(this.speedBps) + '/s';
    },

    etaStr() {
      if (!isFinite(this.etaSec) || this.etaSec <= 0) return '—';
      const s = Math.round(this.etaSec);
      const m = Math.floor(s / 60), r = s % 60;
      return m ? `${m}m ${r}s` : `${r}s`;
    }
  },

  methods: {
    fmtBytes(b) {
      if (b < 1024) return b + ' B';
      if (b < 1024 * 1024) return (b / 1024).toFixed(1) + ' KB';
      if (b < 1024 * 1024 * 1024) return (b / (1024 * 1024)).toFixed(1) + ' MB';
      return (b / (1024 * 1024 * 1024)).toFixed(1) + ' GB';
    },

    async copy(v) {
      try {
        await navigator.clipboard.writeText(v);
      } catch {
        alert('Impossible de copier.');
      }
    }
  }
}
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.card {
  width: min(520px, 92%);
  background: #fff;
  border-radius: 12px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: .9rem;
  text-align: center;
}

.meter {
  height: 10px;
  background: #eee;
  border-radius: 999px;
  overflow: hidden;
}

.bar {
  height: 100%;
  background: #C9A74D;
  transition: width .15s linear;
}

.stats {
  display: grid;
  gap: .35rem;
}

.upload-id {
  display: flex;
  gap: .5rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.copy {
  padding: .3rem .6rem;
  border-radius: 6px;
  border: 1px solid #ddd;
  cursor: pointer;
  background: #fafafa;
  text-decoration: none;
}

.truncate {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hint {
  font-size: .9rem;
  color: #555;
}

.actions {
  display: flex;
  justify-content: center;
}

.actions > button {
  padding: .6rem 1.1rem;
  border-radius: 8px;
  border: 1px solid #ddd;
  cursor: pointer;
  background: #fafafa;
}

.actions > button:disabled {
  opacity: .6;
  cursor: not-allowed;
}
</style>
